/**
 * cart-shipping-sync.js
 * ----------------------------------------------------------------------------
 * Behebt: Versandkosten- und Gesamt-Zeile im Warenkorb aktualisieren sich
 * nach einer Mengen-Aenderung nicht, wenn dabei die Free-Shipping-Schwelle
 * (55 EUR, nur Deutschland) ueber- oder unterschritten wird.
 *
 * Ursache: Die Versand-Zeile wird nur beim Server-Render (Seitenaufruf)
 * berechnet. Der AJAX-Update-Code in assets.js (applyCartUpdate) aktualisiert
 * Zwischensumme, Gesamt und Artikelpreise, laesst die Versand-Zeile aber
 * unangetastet, weil sie keine adressierbare Klasse hat.
 *
 * Strategie: haengt sich global an das jQuery-Ereignis ajaxComplete. Es
 * feuert nach JEDEM abgeschlossenen AJAX-Request, also auch nach assets.js'
 * eigenem applyCartUpdate-Callback. Wir filtern auf Cart-Update-Requests,
 * lesen den frischen Cart-Stand aus der Server-Antwort und setzen Versand-
 * sowie Gesamt-Zeile konsistent zur Free-Shipping-Schwelle.
 *
 * assets.js wird NICHT veraendert. Es entstehen KEINE zusaetzlichen
 * Netzwerk-Requests (wir nutzen die Antwort, die assets.js ohnehin holt).
 *
 * Laender-Logik: Das Liquid rendert data-threshold-cents aus dem Metaobjekt
 * shipping_zone. Fuer Deutschland ist das 5500 (= 55 EUR), fuer alle anderen
 * Laender 0 (es gibt dort keinen Gratis-Versand). Bei Schwelle 0 schaltet
 * die Zeile nie auf "kostenlos" - die Laender-Korrektheit faellt damit
 * automatisch aus dem Metaobjekt, ohne separaten Laender-Check.
 *
 * Erstellt: 2026-05-18
 * ----------------------------------------------------------------------------
 */
(function ($) {
  'use strict';

  if (typeof $ === 'undefined' || !$) return;

  function toInt(value) {
    var n = parseInt(value, 10);
    return isNaN(n) ? 0 : n;
  }

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }
    // Fallback DE-Format, falls Shopify.formatMoney nicht verfuegbar ist
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  /**
   * Setzt jede Versand-Zeile und ggf. die zugehoerige Gesamt-Zeile passend
   * zum aktuellen Cart-Stand.
   * @param {Object} cart  Antwort von /cart/update.js bzw. /cart.js
   */
  function syncShipping(cart) {
    if (!cart || typeof cart.total_price === 'undefined') return;

    // Fix 2026-05-19c: Free-Shipping-Schwelle gegen cart.total_price pruefen
    // (Warenkorbwert NACH Quantum-Breaks-Order-Rabatt) statt items_subtotal_price.
    // Konsistent mit der Geschenk-Logik (header.liquid) sowie der Server-
    // Berechnung in cart-items.liquid / header.liquid und all.js.min.js.
    var subtotalCents = toInt(cart.total_price);
    // cart.total_price aus dem Ajax-Cart ist der Warenkorbwert OHNE Versand
    // (Shopify berechnet Versand erst im Checkout).
    var cartTotalCents = toInt(cart.total_price);

    $('.cart-shipping-value').each(function () {
      var $line = $(this);
      var thresholdCents = toInt($line.attr('data-threshold-cents'));
      var freeText = $line.attr('data-free-text') || 'Kostenlos';

      // Versandpreis-Text fuer den "nicht kostenlos"-Fall:
      // - Warenkorb-Seite: data-shipping-cents ist eine reine Zahl. Daraus
      //   formatieren wir den Text selbst. So landet KEIN money-Markup im
      //   data-Attribut, das je nach shop.money_format Anfuehrungszeichen
      //   enthalten und das Attribut zerbrechen koennte.
      // - Mini-Cart: hat kein data-shipping-cents, dort steht ein fester
      //   Text in data-below-text ("Wird an der Kasse berechnet").
      var shippingAttr = $line.attr('data-shipping-cents');
      var shippingCents = toInt(shippingAttr);
      var belowText;
      if (typeof shippingAttr !== 'undefined') {
        belowText = formatMoney(shippingCents);
      } else {
        belowText = $line.attr('data-below-text') || '';
      }

      // thresholdCents == 0 (aus dem Metaobjekt fuer Nicht-DE-Laender)
      // bedeutet: kein Gratis-Versand. Die Zeile schaltet dann nie auf
      // "kostenlos", egal wie hoch der Warenkorbwert ist.
      var isFree = thresholdCents > 0 && subtotalCents >= thresholdCents;

      // 1) Versand-Zeile umschalten: Gratis-Text oder Versandpreis.
      $line.html(isFree ? freeText : belowText);

      // 2) Gesamt-Zeile nur dort neu berechnen, wo die Versand-Zeile sie
      //    beeinflusst (Warenkorb-Seite: Gesamt = Items + Versand-Schaetzung).
      //    Der Mini-Cart-Drawer zeigt das Gesamt bewusst ohne Versand und
      //    traegt deshalb kein data-affects-total.
      if ($line.attr('data-affects-total') === 'true') {
        var displayTotalCents = isFree
          ? cartTotalCents
          : cartTotalCents + shippingCents;

        // .total_price im selben Summen-Block, mit globalem Fallback.
        var $box = $line.closest('.to-the-checkout-box, #sliding-cart-bottom');
        var $total = $box.length ? $box.find('.total_price') : $('.total_price');
        $total.html(formatMoney(displayTotalCents));
      }
    });
  }

  // Globaler Hook: feuert nach jedem abgeschlossenen jQuery-AJAX-Request.
  // jQuery-Reihenfolge garantiert: erst der lokale success-Callback von
  // assets.js (setCartWithData), DANN dieser ajaxComplete-Handler. Damit
  // steht unser korrigierter Wert zuletzt.
  $(document).ajaxComplete(function (event, xhr, settings) {
    var url = (settings && settings.url) || '';
    if (url.indexOf('/cart/update') === -1 && url.indexOf('/cart/change') === -1) {
      return;
    }

    var cart = xhr && xhr.responseJSON;
    if (!cart && xhr && xhr.responseText) {
      try {
        cart = JSON.parse(xhr.responseText);
      } catch (e) {
        return;
      }
    }
    syncShipping(cart);
  });

})(jQuery);
